import * as getter from '../types/getters'
import * as action from '../types/actions'
import linq from 'linq'
import { classValidate } from '../../utility/validateUtility'
import { filterAndDestroy } from '../../utility/objectUtility'
import ItemSelectViewModel from '../../viewModel/ItemSelectViewModel'

export const state = {
    itemSelect: new ItemSelectViewModel(),
}

export const mutations = {
    [action.FETCH_ITEM_SELECT](state, itemSelect) {
        state.itemSelect = itemSelect
    },
}

export const actions = {
    async [action.FETCH_ITEM_SELECT]({ commit }) {
        const { data } = await axios.get('/api/items/get-select')

        const itemSelect = new ItemSelectViewModel(data)
        commit(action.FETCH_ITEM_SELECT, itemSelect)
    },
}

export const getters = {
    [getter.ITEM_SELECT]: (state) => state.itemSelect,
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/itemSelect.js